var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_154787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.0366C15.3725 10.0366 15 10.41 15 10.8699V17.5366C15 17.9957 14.6266 18.3699 14.1667 18.3699H2.5C2.03995 18.3699 1.66672 17.9957 1.66672 17.5366V5.86987C1.66672 5.41074 2.03995 5.03659 2.5 5.03659H9.16672C9.62753 5.03659 10 4.66321 10 4.20331C10 3.74326 9.62753 3.36987 9.16672 3.36987H2.5C1.12167 3.36987 0 4.49155 0 5.86987V17.5366C0 18.9149 1.12167 20.0366 2.5 20.0366H14.1667C15.545 20.0366 16.6667 18.9149 16.6667 17.5366V10.8699C16.6667 10.4091 16.2941 10.0366 15.8333 10.0366Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81295 9.2757C7.75466 9.33398 7.71545 9.40814 7.69882 9.4881L7.10967 12.4349C7.08221 12.5714 7.12554 12.7123 7.22381 12.8115C7.303 12.8907 7.40966 12.9331 7.51891 12.9331C7.54546 12.9331 7.57308 12.9306 7.60055 12.9248L10.5464 12.3357C10.628 12.3189 10.7022 12.2798 10.7597 12.2214L17.3531 5.62808L14.4072 2.68237L7.81295 9.2757Z",
    fill: "#1253FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3892 0.646019C18.5768 -0.166512 17.2551 -0.166512 16.4433 0.646019L15.29 1.79928L18.2359 4.74514L19.3892 3.59173C19.7825 3.19927 19.9992 2.6759 19.9992 2.11925C19.9992 1.56261 19.7825 1.03924 19.3892 0.646019Z",
    fill: "#1253FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_154787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.166fbf7543f4ef577c77068b353c40e3.svg";
export { ForwardRef as ReactComponent };